export default "__VITE_ASSET__EYY4L0Fp__"